import { IChecklistItemRow } from "@mctypes/checklist.types";
import { useState } from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import CreateItemWithBoardSelectorModal from "../../../components/CreateItemWithBoardSelectorModal/CreateItemWithBoardSelectorModal";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { MCApplicationsUrlEnum } from "../../../mc-shared/sharedConstants";
import ConnectExistingIssueToItemModalWrapper from "../../ConnectExistingIssueToItemModalWrapper";
import { useGetIssueBoardsQuery } from "../issuesApp/IssueBoardRTK";
import { connectOrDisconnectIssueFromChecklistItemThunk, createIssueOnChecklistItemThunk } from "./checklistSlice";

const ChecklistConnectIssue: React.FC<{ checklistRow: IChecklistItemRow; projectId: string }> = ({
  checklistRow,
  projectId,
}) => {
  const dispatch = useAppDispatch();
  const apps = useAppSelector((state) => state.globalReducer.apps);

  const { data: issueBoards = [] } = useGetIssueBoardsQuery({
    projectId: projectId,
  });

  const [newIssueModalOpen, setNewIssueModalOpen] = useState<boolean>(false);
  const [connectExistingModalOpen, setConnectExistingModalOpen] = useState<boolean>(false);

  const onCreateIssue = (boardId: string) => {
    dispatch(createIssueOnChecklistItemThunk(boardId, checklistRow._id));
    setNewIssueModalOpen(false);
  };

  const onConnect = (issueId: string) => {
    dispatch(connectOrDisconnectIssueFromChecklistItemThunk(checklistRow._id, issueId, "CONNECT"));
    setConnectExistingModalOpen(false);
  };

  return (
    <>
      <ConnectExistingIssueToItemModalWrapper
        opened={connectExistingModalOpen}
        onConnected={(boardId, issueId) => onConnect(issueId)}
        projectId={projectId}
        closeModal={() => setConnectExistingModalOpen(false)}
        blockedIssueIds={(checklistRow.connectedIssues || []).map((issue) => issue._id)}
      />
      <CreateItemWithBoardSelectorModal
        boards={(issueBoards || []).map((board) => {
          return {
            project: board.project,
            name: board.name,
            _id: board._id,
            status: board.status,
          };
        })}
        onCreate={onCreateIssue}
        modalTitle="Koble sak til sjekklistepunkt"
        opened={newIssueModalOpen}
        onClose={() => setNewIssueModalOpen(false)}
        currentApp={MCApplicationsUrlEnum.ISSUE}
        apps={apps}
        projectId={projectId}
        createButtonText="Opprett sak"
      />
      <UncontrolledDropdown>
        <DropdownToggle color="success" outline size="sm" style={{ padding: "4px 0.4rem", height: "1.5rem" }}>
          <i className="fa fa-plus fa-fw" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => setNewIssueModalOpen(true)}>Ny</DropdownItem>
          <DropdownItem onClick={() => setConnectExistingModalOpen(true)}>Koble eksisterende</DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
};

export default ChecklistConnectIssue;
